export default __webpack_public_path__ + "static/media/misc-pantry1-480w.3421a2c0.avif";